export const IS_VISIBLE = 'is-visible';
export const IS_HIDDEN = 'is-hidden';
export const IS_ENTERING = 'is-entering';
export const IS_LEAVING = 'is-leaving';
export const IS_FULL_HEIGHT = 'is-full-height';
export const HEIGHT_TRANSITION = 'height-transition';
export const FADE_IN = 'fade-in';
export const FADE_OUT = 'fade-out';
